export const TAAZE_WEBSITE = 'https://www.taaze.tw/';
export const TAAZE_USER_PAGE_URL = 'https://www.taaze.tw/custManageIndex.html?tFlg=D';
export const TAAZE_T_POINT_HISTORY_PAGE_URL = 'https://www.taaze.tw/listMyTpoint.html?typeFlg=FE'

export const TALK_TO_THE_BOOKS_FEEDBACK_FORM = 'https://docs.google.com/forms/d/e/1FAIpQLSe7yFV41_Fls2LVak1uS1fi0tX_goGBWdrRh69sGO-tQiNCWw/viewform';

export const OCOPY_WELCOME_MESSAGE = `嗨！歡迎來到 Talk to the Books，開啟全新的閱讀體驗，讓閱讀更智慧！`;

export const SHARE_RESPONSE_MESSAGE = `我在讀冊生活用AI來問答此書的內容，感覺很有意思，這回答內容推薦你來看看`
